import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import { FormPopupProvider } from './contexts/FormPopupContext';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Products from './pages/Products';
import Experience from './pages/Experience';
import Warranty from './pages/Warranty';
import Contact from './pages/Contact';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Pro8KProjector from './pages/products/Pro8KProjector';
import ImmersionSurround from './pages/products/ImmersionSurround';
import StudioSoundbar from './pages/products/StudioSoundbar';
import VisionScreen from './pages/products/VisionScreen';
import TowerMonitor from './pages/products/TowerMonitor';

// Placeholder pages - will be created later

// Contact page moved to separate component

const ProductDetailPage = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gradient mb-4">Product Details</h1>
      <p className="text-secondary">Coming Soon - Detailed product specifications</p>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <FormPopupProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/pro-8k-projector" element={<Pro8KProjector />} />
            <Route path="/products/immersion-surround" element={<ImmersionSurround />} />
            <Route path="/products/studio-soundbar" element={<StudioSoundbar />} />
            <Route path="/products/vision-screen" element={<VisionScreen />} />
            <Route path="/products/tower-monitor" element={<TowerMonitor />} />
            <Route path="/products/:productId" element={<ProductDetailPage />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/warranty" element={<Warranty />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </Layout>
      </FormPopupProvider>
    </Router>
  );
}

export default App;
